import { useLayoutEffect, useRef, useState } from 'react'

type Axis = 'horizontal' | 'vertical'

export const useIsTruncated = (content: string, axis: Axis = 'horizontal') => {
  const ref = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current

    if (!el) {
      return
    }

    setIsTruncated(axis === 'vertical' ? el.scrollHeight > el.clientHeight : el.scrollWidth > el.clientWidth)
  }, [axis, content])

  return [ref, isTruncated] as const
}
